module.exports = __webpack_public_path__ + "assets/img/sad_baby2.a04d2945.jpg";